const messages = {
  seasons: {
    all: "Całoroczne",
    summer: "Lato",
    winter: "Zima",
    general: "Ogólne",
  },
  offer:
    "Regularnie rozszerzamy naszą <br />ofertę dla Ciebie! <br /><br />O nowych szkoleniach poinformujemy Cię w skrzynce odbiorczej.",
  summary: {
    congratulations: "GRATULACJE - UKOŃCZYŁEŚ SZKOLENIE Z ZAKRESU",
    participation:
      "Pomyślnie ukończyłeś szkolenie online Transporter All-Season Tires.",
    certificate:
      "Twój certyfikat zostanie wysłany e-mailem lub możesz pobrać go tutaj bezpośrednio jako PDF:",
    send: "Pobierz certyfikat",
  },
  online: {
    title: "Nasze szkolenia online",
    desc: "Zdobądź ekspercką wiedzę, a po pomyślnym ukończeniu testów szkoleniowych otrzymaj<br> imienny certyfikat uczestnictwa oraz jednorazowo 40 dodatkowych punktów do klubu premium",
    content:
      "Poznaj nasze aktualne szkolenia online i weź udział od razu na platformie tutaj:",
    categories: {
      title: "Szkolenia online",
      description:
        "Bądź o krok przed innymi dzięki wiedzy: zdobądź unikalne kompetencje dla siebie i zespołu dzięki naszej ofercie szkoleń. Skorzystaj ze szkoleń online dostępnych bezpośrednio na platformie, kursów i seminariów praktycznych w Centrum Szkoleniowym Bridgestone oraz szkoleń zewnętrznych, których koszt możesz obniżyć punktami premium.",
      general: {
        title: "Ogólne",
        subtitle: "Szkolenie online: Ogólne",
        description:
          "Poznaj najnowsze technologie, istotne trendy w branży oponiarskiej, wskazówki sprzedażowe i wiele więcej.",
        subdesription:
          "Zdobądź ekspercką wiedzę, a po pomyślnym ukończeniu testów szkoleniowych otrzymaj imienny certyfikat uczestnictwa oraz jednorazowy bonus 40 dodatkowych punktów do klubu premium.",
      },
      product: {
        title: "Produkty",
        subtitle: "Szkolenie online: Produkty",
        description:
          "Pogłęb wiedzę produktową Bridgestone i Firestone, aby skuteczniej sprzedawać dzięki naszym krótkim materiałom szkoleniowym.",
        subdesription:
          "Zdobądź ekspercką wiedzę, a po pomyślnym ukończeniu testów szkoleniowych otrzymaj imienny certyfikat uczestnictwa oraz jednorazowy bonus 40 dodatkowych punktów do klubu premium.",
      },
    },
  },
  lectures: {
    title: "Szkolenia Bridgestone",
    desc: "Rozwijaj kompetencje i rezerwuj nasze szkolenia oraz szkolenia intensywne dla siebie i zespołu. Możesz uczestniczyć w szkoleniach w Bridgestone Competence and Training Center w Dietzenbach (niedaleko Frankfurtu nad Menem) albo - dla wybranych szkoleń - zrealizować je w swojej firmie. Na szkolenia możesz wykorzystać punkty bonusowe i pokryć nimi koszty w całości lub częściowo.",
    content: "Sprawdź aktualne szkolenia i wyślij zgłoszenie rezerwacji:",
  },
  singleLecture: {
    registerForm: {
      title: "Zakres szkolenia",
      inquiry: "Zapytanie",
      interested: "Jestem zainteresowany szkoleniem",
      participantsNr: "Liczba uczestników",
      pointsFromBalance: "Chcę wykorzystać punkty z salda punktowego.",
      reduction: "To odpowiada obniżeniu kosztu o {points} euro.",
      request: "Wyślij zgłoszenie",
    },
    success: {
      thanks: "Dziękujemy",
      title: "Twoje zapytanie zostało wysłane do zespołu szkoleniowego.",
      feedbackTime:
        "Otrzymasz odpowiedź w ciągu 14 dni, aby doprecyzować wszystkie szczegóły.",
      points:
        "Wykorzystane punkty bonusowe w liczbie<br /><strong>{points}</strong> zostały odjęte z Twojego<br />konta punktowego.",
      refund:
        "Jeśli szkolenie się nie odbędzie, punkty zostaną oczywiście zwrócone.",
      queries: "W razie pytań skontaktuj się z:",
    },
    index: {
      costs: "Koszty i informacje o uczestnictwie",
      duration: "Czas trwania: {duration}",
      cost: "Koszt {cost}: {price} euro",
      participantsNr: "Uczestnicy: min. {min} - maks. {max} osób",
    },
  },
  index: {
    title: "Szkolenia i edukacja",
    desc: "Przewaga dzięki wiedzy: zdobądź specjalistyczną wiedzę dla siebie i zespołu dzięki naszej ofercie szkoleniowej. Skorzystaj ze szkoleń online dostępnych bezpośrednio na platformie, szkoleń i seminariów praktycznych w centrum szkoleniowym Bridgestone lub szkoleń zewnętrznych, których koszty możesz obniżyć punktami.",
    online: {
      title: "Szkolenia online",
      desc: "Weź udział bezpośrednio na platformie i zdobądź {points} punktów do klubu premium.",
    },
    lectures: {
      title: "Szkolenia",
      desc: "Wysokiej jakości szkolenia w naszym centrum szkoleniowym lub w Twojej lokalizacji.",
    },
    external: {
      title: "Szkolenia zewnętrzne",
      desc: "Wykorzystaj punkty bonusowe na oferty zewnętrznych dostawców i obniż koszty.",
    },
  },
  single: {
    done: "Szkolenie zakończone.",
    doneDownloadCertificate: "Szkolenie zakończone. Pobierz certyfikat.",
  },
  certificate: {
    header: "CERTYFIKAT",
    atCourse: "pomyślnie uczestniczył(a) w",
    takePart: "kursie.",
    contains: "ZAKRES KURSU",
    country: "Polska",
  },
};

export default {
  messages,
};
